import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath } from "react-katex";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";
import LongitudinalBar from "../components/LongitudinalBar.js";

import { concreteFatigue } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function ConcreteFatigue({}) {
  const toast = useToast();
  // BENDING
  const [fatigueInputs, setFatigueInputs] = useState({
    fck: 20,
    fyk: 500,
    b: "",
    h: "",
    dl: "",
    m_min: "",
    m_max: "",
    as_adot: "",
  });
  const [fatigueOutputs, setFatigueOutputs] = useState({
    tens_cd_max: "",
    fcd_fad: "",
    delta_fsd_fad: "",
    delta_fsd_fad_min: "",
    memorial: {},
  });

  function updateFatigueInputs(name, value) {
    if (value === "") {
      setFatigueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setFatigueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setFatigueOutputs({
      ln: "",
      domain: "",
      ast: "",
      asc: "",
      ast_min: "",
    });
  }

  function onFatigueCalculate() {
    if (
      fatigueInputs["b"] === "" ||
      fatigueInputs["h"] === "" ||
      fatigueInputs["dl"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      fatigueInputs["b"] === 0 ||
      fatigueInputs["h"] === 0 ||
      fatigueInputs["dl"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      concreteFatigue(fatigueInputs).then((response) => {
        setFatigueOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "concrete-fatigue-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "concrete-fatigue-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Fadiga:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="fck"
              elements={[
                20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
              ]}
              unit="MPa"
              onChange={(e) => updateFatigueInputs("fck", e.target.value)}
            />
            <Select
              text="fyk"
              elements={[500]}
              unit="MPa"
              onChange={(e) => updateFatigueInputs("fyk", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateFatigueInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateFatigueInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="dl"
              unit="cm"
              onChange={(e) => updateFatigueInputs("dl", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Mmín"
              unit="tf.m"
              onChange={(e) => updateFatigueInputs("m_min", e.target.value)}
            />
            <InputNumber
              text="Mmáx"
              unit="tf.m"
              onChange={(e) => updateFatigueInputs("m_max", e.target.value)}
            />
          </div>
          <div className={styles.inputElement}>
            <LongitudinalBar input="as_adot" onChange={updateFatigueInputs} />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onFatigueCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <Output
            text="Verif. concreto"
            value={
              fatigueOutputs["tens_cd_max"] + "<" + fatigueOutputs["fcd_fad"]
            }
          />
          <Output
            text="Verif. armadura"
            value={
              fatigueOutputs["delta_fsd_fad"] +
              "<" +
              fatigueOutputs["delta_fsd_fad_min"]
            }
          />
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {fatigueOutputs["memorial"] &&
          Object.entries(fatigueOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default ConcreteFatigue;
